export const MAX_TITLE_LENGTH = 100
export const MAX_DESCRIPTION_LENGTH = 5000
